import React from 'react';
import ClientDashboard from './ClientDashboard';

function CompletedProjects() {
  return <ClientDashboard defaultTab="completed" />;
}

export default CompletedProjects;